import React from 'react';
import { hidePopup } from '../../helpers/uiFunctions/uiActions';

class DuplicatePromoForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return(
            <form className="form popup-form" id="dupePromoForm" style={{display: 'none'}}>
                <i className="fas fa-times icon" onClick={() => hidePopup("dupePromoForm")} style={{float: 'right'}}></i>
                <h3>Duplicate Promotion</h3>
                <p className="promo-error"></p>
                <div className="input-row">
                    <input type="text" className="input" id="dupePromoName" placeholder="Duplicate Promotion Name" />
                </div>
                <div className="input-row">
                    <label>Start Date</label>
                    <input type="date" id="dupePromoStart" name="promoStart" />
                </div>
                <div className="input-row">
                    <label>End Date</label>
                    <input type="date" id="dupePromoEnd" name="promoEnd" />
                </div>
                <input type="button" className="button is-info" id="dupeSubmit" value="Copy Promotion" onClick={() => this.props.promoDuplicate()} />
            </form>
        )
    }
}
export default DuplicatePromoForm;


// WEBPACK FOOTER //
// ./src/component_promotions/Explorer/DupePromo.js